/**
 * Whether public self-serve tenant signup is offered on this deployment.
 *
 * Opt-in: only the literal "true" enables it, so an unset or misspelled value keeps
 * signup hidden. Set per customer in `deployments/customers/<id>/.env.production`,
 * which the Dockerfile copies over `.env.production` at image build — Vite inlines it,
 * so changing this requires a rebuild, not just a redeploy.
 *
 * This is a SEPARATE switch from the API's `TENANT_SIGNUP_ENABLED`, and the two must be
 * set consistently. If this is on while the API's is off, the form renders and the
 * submit fails with the `signupDisabled` notification.
 *
 * Note this gates only the /signup entry point. /activate-tenant and /resend-activation
 * stay reachable regardless — see the comments in routes/authRoutes.tsx.
 */
export const isTenantSignupEnabled =
  import.meta.env.VITE_TENANT_SIGNUP_ENABLED === "true";
